import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { GroupsModel } from '../models/GroupsModel';
import { URLsConfig } from '../URLsConfig';
@Injectable()
export class GroupsService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }


  public getGroupsLookupTop(compCode: string) {
      let params = new HttpParams();
      params = params.append("compCode", compCode);
      const options = {
          params: params
      };
      return this.http.get<GroupsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Groups/GroupsLookupTop', options);
  }
}
